export const SIMERA_FEE = 600;
